<template>
  <page>
    <div class="m-grid__item m-grid__item--fluid m-wrapper">
      <div class="m-subheader ">
        <div class="d-flex align-items-center">
          <div class="mr-auto">
            <h1 class="m-subheader__title m--margin-top-15-mobile" v-encode="pageTitle">
            </h1>
          </div>
        </div>
        <div class="row m--visible-mobile">
          <div class="col">
          </div>
        </div>
      </div>

      <div v-if="goals.length" class="m-content">
        <div class="row">
          <goal v-for="goal in goals.slice(0, showOnPage)" :goal="goal" :key="goal.id" @refresh="refresh"></goal>
        </div>
        <div v-if="isThereMore" class="row">
          <div class="col m--align-center">
            <button type="button" class="btn btn-sm m-btn--custom m-btn--pill btn-ls"
                    @click="showMore">{{$t('Load more')}}
            </button>
          </div>
        </div>
      </div>
      <div v-else-if="isLoading" class="m-content text-center">
        <spinner></spinner>
      </div>
      <div v-else class="m-content text-left" >
        <div class="m-portlet m-portlet--full-height">
          <div class="m-portlet__body">
            <div class="tab-content">
              <div class="tab-pane active" id="m_widget2_tab1_content" aria-expanded="true">
                {{$t('No data')}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </page>
</template>

<script>
import Page from "./Page";
import {mapActions, mapState} from 'vuex';
import ClickOutside from 'vue-click-outside'
import Encode from "@/directives/encode";
import Spinner from "../spinner/Spinner";
import Goal from "../goal/Goal";
import BeforeRoute from '@/mixins/beforeRoute'
import PageTitle from "@/mixins/pageTitle";

export default {
  name: "GoalsPage",
  components: {Goal, Spinner, Page},
  mixins: [
      BeforeRoute('fetchGoals'),
      PageTitle('Cele grupowe'),
  ],
  directives: {
    ClickOutside,
    Encode
  },
  data() {
    return {
      isLoading: false,
      showOnPage: 6,
    }
  },
  methods: {
    ...mapActions([
      'fetchGoals',
      'fetchUser',
    ]),
    showMore() {
      this.showOnPage += 6;
    },
    refresh() {
      this.fetchGoals();
      this.fetchUser();
    }
  },
  computed: {
    ...mapState({
      goals: state => state.goals.goals
    }),
    isThereMore() {
      return this.goals.length > this.showOnPage;
    },
  },
}

</script>

<style scoped>

</style>
